module.exports = __webpack_public_path__ + "assets/img/rankt.a4973e41.png";